import type { AvailableSeason, SeasonStatus } from '@/pages/SeasonSelectionPage/SeasonCard'

export function getSeasonStatus(season: string, now = new Date()): SeasonStatus {
  const [prefix, shortYear] = season.split(' ')
  const year = 2000 + Number.parseInt(shortYear, 10)

  // SS: Feb 1 – Jul 31, AW: Aug 1 – Jan 31 of year+1
  const start = prefix === 'SS' ? new Date(year, 1, 1) : new Date(year, 7, 1)
  const end = prefix === 'SS' ? new Date(year, 6, 31) : new Date(year + 1, 0, 31)

  if (now < start)
    return 'in-progress'
  if (now > end)
    return 'archived'
  return 'active'
}

export function generateDynamicSeasons(): AvailableSeason[] {
  const currentYear = new Date().getFullYear()
  const firstYear = currentYear - 1
  const lastYear = currentYear + 4

  const seasons: string[] = []

  for (let year = firstYear; year <= lastYear; year++) {
    const shortYear = String(year).slice(-2)
    seasons.push(`SS ${shortYear}`, `AW ${shortYear}`)
  }
  return seasons.map(season => ({
    season,
    status: getSeasonStatus(season),
  }))
}

export function getCurrentSeason(date = new Date()) {
  const month = date.getMonth()
  const yearTwoDigits = date.getFullYear().toString().slice(-2)
  const prefix = month < 6 ? 'SS' : 'AW'
  return `${prefix}${yearTwoDigits}`
}

export function getDefaultSeasons(): string[] {
  const now = new Date()
  const currentMonth = now.getMonth()
  const currentYear = now.getFullYear()

  let seasonPrefix: string
  let seasonYear: number

  if (currentMonth <= 5) {
    seasonPrefix = 'SS'
    seasonYear = currentYear + 1
  }
  else {
    seasonPrefix = 'AW'
    seasonYear = currentYear + 2
  }
  const shortYear = String(seasonYear).slice(-2)
  const calculatedSeason = `${seasonPrefix} ${shortYear}`

  return [calculatedSeason, calculatedSeason]
}
